export default "__VITE_ASSET__Un1LzkpB__"